import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserInfo } from 'angular-oauth2-oidc';
import { BehaviorSubject, Observable, of, throwError, zip } from 'rxjs';
import { delay, map, tap, zipAll } from 'rxjs/operators';
// import { AuthConfig, OAuthService, OAuthStorage, UrlHelperService } from 'angular-oauth2-oidc';
// import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { environment } from 'src/environments/environment';
import { SigninResponse } from '../signin-response.interface';
import { Signin } from '../signin.interface';
import { Token } from '../token';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // authConfig: AuthConfig = environment.authCodeFlowConfig;

  // isAuth = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    // private urlHelper: UrlHelperService,
    // private authStorage: OAuthStorage,
    // private oauthService: OAuthService
    ) {
      // this.isAuth.next(this.checkAuth());
  }

  initializeSSO() {
    // this.initSessionChecks();
    // this.oauthService.configure(this.authConfig);
    // this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    // this.oauthService.loadDiscoveryDocumentAndTryLogin();
    // console.log('sso initialized');
  }

  private initSessionChecks(): void {
    // The oidc lib does not support session checks with code flow (yet)
    // but we can work around this limitation by manually setting
    // the storage key if a session_state querystring value is available
    // if (typeof window !== 'undefined') {
    //   let queryString = window.location.search;
    //   if (queryString.charAt(0) === '?') {
    //     queryString = queryString.substr(1);
    //   }
    //   const parts: any = this.urlHelper.parseQueryString(queryString);
    //   if (parts && parts.session_state) {
    //     console.log(parts.session_state);
    //     this.authStorage.setItem('session_state', parts.session_state);
    //   }
    // }
  }

  signin() {
    // this.oauthService.initLoginFlow();

    // tslint:disable-next-line:max-line-length
    const url = `${environment.maxisSSO}?response_type=${environment.authCodeFlowConfig.responseType}&client_id=${environment.authCodeFlowConfig.clientId}&state=TTVTbE5nfmVtZ09mdlRoUF9-LnBpcV9pQTFIUjNsWEJncGd1M1U1bkcyVmUy&redirect_uri=${encodeURIComponent(environment.authCodeFlowConfig.redirectUri)}&scope=${environment.authCodeFlowConfig.scope}&nonce=TTVTbE5nfmVtZ09mdlRoUF9-LnBpcV9pQTFIUjNsWEJncGd1M1U1bkcyVmUy`;
    window.location.href = url;

  }

  postCodeToBackend(code: string): Observable<SigninResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        accept: 'text/plain',
        'content-type': 'text/plain'
      }),

    };

    httpOptions.headers.delete('content-type');

    // tslint:disable-next-line:max-line-length
    const url = environment.apiBaseUrl + 'Auth/DIDLogin?ReturnUrl=' + encodeURIComponent(environment.authCodeFlowConfig.redirectUri) +  '&AuthCode=' + code;
    return this.http.post<SigninResponse>(url, '', httpOptions);

  }
  signout(): Observable<string> {

    const game360SignOutUrl = environment.apiBaseUrl + 'Auth/Logout';

    if (environment.production) {
      return this.http.get<{Success: boolean, Message: string}>(game360SignOutUrl)
            .pipe(
              map(resp => resp.Success ? resp.Message : throwError(new Error(resp.Message))),
              tap(() => this.maxisSSOSignout())
            ) as Observable<string>;

    } else {

      return of('OK. Development.');

    }
  }

  maxisSSOSignout(): void {
    const maxisSignOutUrl = environment.maxisSignOut;
    window.location.href = maxisSignOutUrl;
  }

  confirmNewUser(auth: {Token: string; UUID: string; }): Observable<SigninResponse> {
    const url = environment.apiBaseUrl + `Auth/ConfirmNewUserCallBack?uuid=${auth.UUID}&token=${encodeURIComponent(auth.Token)}`;
    const httpOptions = {
      headers: new HttpHeaders({
        accept: 'text/plain',
        'content-type': 'text/plain'
      }),

    };
    httpOptions.headers.delete('content-type');
    return this.http.post<SigninResponse>(url, '', httpOptions);
  }

  userInfo(): Observable<Signin> {
    const url = environment.production ? environment.apiBaseUrl + 'Auth/GetUserInfo' : environment.apiBaseUrl + 'Auth/GetUserInfo2242';
    return this.http.get<Signin>(url);
  }
}
